'use strict';

var maxLength = function maxLength(array, from, to) {
  return Math.ceil(array.length * Math.log2(from) / Math.log2(to));
};

function baseConvertIntArray(array, _ref) {
  var from = _ref.from,
      to = _ref.to,
      _ref$fixedLength = _ref.fixedLength,
      fixedLength = _ref$fixedLength === void 0 ? null : _ref$fixedLength;
  var length = fixedLength === null ? maxLength(array, from, to) : fixedLength;
  var result = new Array(length); // Each iteration prepends the resulting value, so start the offset at the end.

  var offset = length;
  var input = array;

  while (input.length > 0) {
    if (offset === 0) {
      throw new RangeError("Fixed length of ".concat(fixedLength, " is too small, expected at least ").concat(maxLength(array, from, to)));
    }

    var quotients = [];
    var remainder = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var digit = _step.value;
        var acc = digit + remainder * from;
        var q = Math.floor(acc / to);
        remainder = acc % to;

        if (quotients.length > 0 || q > 0) {
          quotients.push(q);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    result[--offset] = remainder;
    input = quotients;
  } // Trim leading padding, unless length is fixed.


  if (fixedLength === null) {
    return offset > 0 ? result.slice(offset) : result;
  } // Fill in any holes in the result array.


  while (offset > 0) {
    result[--offset] = 0;
  }

  return result;
}

module.exports = baseConvertIntArray;